import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetAgentSessionsQuery,
  GetAgentSessionsQueryVariables,
} from "./GetAgentSessions.generated";

export const GET_AGENT_SESSIONS: TypedDocumentNode<
  GetAgentSessionsQuery,
  GetAgentSessionsQueryVariables
> = gql`
  query getAgentSessions($limit: Int, $offset: Int) {
    agentSessions(limit: $limit, offset: $offset) {
      uuid
      managedSessionId
      title
      createdAt
      effort
    }
  }
`;
